<template>
    <div class="c-step-buttons">
        <div class="c-step-buttons--loader">
            <div :class="[running ?'a-loader a-loader--step-button':'']"></div>
        </div>
        <div class="step-button flex-state-buttons">
            <button class="a-button" :disabled="!prevValid" :class="!prevValid ?'disabled':''" @click="back">
                Back
            </button>
            <button class="a-button" :disabled="!nextValid || running" :class="[!nextValid || running ?'disabled':'']" @click="next">
                Next
            </button>
        </div>
        <br>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { nextStep, prevStep } from 'services/routingMethods';

    export default {
        name: 'step-button',
        props: {
            prevValid: {
                type: Boolean,
                default: true,
            },
            nextValid: {
                type: Boolean,
                default: false,
            },
        },
        computed: mapGetters('http', ['running']),
        methods: {
            next () {
                if (this.nextValid) {
                    this.$router.push(nextStep().route);
                }
            },
            back () {
                if (this.prevValid) {
                    this.$router.push(prevStep().route);
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// StepButton.vue?63ff58ee